import React, { Component, Fragment } from "react";
import { Card, CardBody, Table, Button ,Row} from "reactstrap";
import { Colxx, Separator } from "../../../components/shared/CustomBootstrap";
import {useSelector} from 'react-redux'
import {encodePhoneNumber} from "../../../helpers/Utils"

export default function Profile() {
const authUser=useSelector((state)=>state.authUser)
  return (
    <Fragment>
   
    <Row>
      <Colxx xxs="12">
      <Card className="dashboard-link-list">
        <CardBody>
            <div className="d-flex flex-row">
                <div className="w-100">
                    <Table bordered>
                        <thead>
                            <tr>
                                <th width="30%">First name</th>
                                <td width="70%">{authUser.user.first_name}</td>
                            </tr>
                            <tr>
                                <th width="30%">Last name</th>
                                <td width="70%">{authUser.user.last_name}</td>
                            </tr>
                            <tr>
                                <th width="30%">Username</th>
                                <td width="70%">{authUser.user.email}</td>
                            </tr>
                            <tr>
                                <th width="30%">Phone number</th>
                                <td width="70%">{encodePhoneNumber(authUser.user.accounts.find( x => x.id == authUser.activeAccount).phone)}</td>
                               {/*<td>{
                                    this.maskPhone("aaa") ? 
                                    this.maskPhone("aaa") 
                                    : 
                                    <Button className="btn-xs" color="secondary" onClick={() => this.showBusinessModal() }>Setup</Button>
                                  }
                                </td>*/}
                            </tr>
                        </thead>
                        
                    </Table>
                    
                </div>
            </div>
        </CardBody>
        </Card>
      </Colxx>
    </Row>
    
  </Fragment>
  )
}
